import maneuverScheduleZh from "./maneuverScheduleZh";

export default {
    nav: {
        index: "首页",
        about: "展会概况",
        exhibition: "展会介绍",
        pavilion: "展馆介绍",
        traffic: "交通指引",
        exhibitor: "展商服务",
        exhibitor_signup: "展商报名",
        exhibitor_directory_2025: "2025博览会展商名录",
        exhibitor_spotlight: "展商风采",
        participation_manual: "参展手册",
        activities: "观众服务",
        activity_reg: "观众登记",
        activity_list: "同期活动",
        activity_guide: "参观指南",
        presentation: "展会介绍",
        service: "展商服务",
        viewers: "观众服务",
        news: "展会新闻",
        contact: "联系我们"
    },
    common: {
        plh: "请输入",
        slp: "请选择",
        exhibition: "展会概况",
        scope: "展示范围",
        themesev: "7大主题，",
        ciogl: "全面诠释绿色低碳",
        highlights: "展会亮点",
        highlightsText: "模XX、覆盖xxx领域",
        learnmore: "了解详情",
        highlightsEvents: "精彩活动",
        atlas: "展示图册",
        exhibiting: "参展名企",
        onsiteMedia: "现场媒体",
        indexTitle: "2023江苏绿色低碳建筑国际博览会将于10月在南京举行",
        indexSubTitle: "本次博览会以“绿色城乡，迈向更低碳的未来”为主题，由江苏省住房和城乡建设厅、中国国际贸易促进委员会江苏省分会共同主办。据江苏省住建厅总工程师路宏伟介绍，博览会将重点展示绿色低碳发展最新成果",
        checkDetail: "查看详情",
        zhanhuiMsg: "展会消息",
        lobbies: "供采大厅",
        lobbiesTitle: "一键对接供采双方需求",
        lobbiesSubTitle: "提交采购意向 -> 推荐供应产品 -> 参展商响应",
        mybuyer: "我是采购商",
        publishing: "发布需求",
        myExhibitor: "我是参展商",
        finding: "寻找商机",
        contactUs: "联系我们",
        contactUs2: "联系方式",
        contactUsSub: "您可以通过以下方式与我们取得联系，欢迎您的来电",
        telephones: "电话",
        mail: "邮箱",
        address: "地址",
        addressText: "南京市建邺区江东中路300号",
        publicNumber: " 公众号",
        publicNumberText: " 扫描二维码更多了解我们",
        outlogin: '退出登录'
    },
    home: {
        expoProfileTitle: "展会介绍",
        expoProfileSubtitle: "Exhibition Introduction",
        expoProfileText: "江苏作为东部发达省份和和经济大省，产业集聚度高，建设科技成果丰富。“江苏绿色低碳建筑国际博览会”是业内最具规模的优质品牌展会之一，致力于打造综合性，专业化，全链型服务平台，推动住房城乡建设领域技术推广产品交易，项目对接，产金合作，人才交流，受到社会各界的广泛关注和一致好评。",
        expoNewsTitle: "展会新闻",
        expoNewsSubtitle: "EXPO NEWS",
        expoRecoTitle: "展商推荐",
        expoRecoSubtitle: "EXPO RECOMMENDED",
        expoRecoNote: "（展商顺序随机排列）",
        sourcingSubtitle: "SOURCING HALL",
        contactTitle: "联系我们",
        contactSubtitle: "CONTACT US",
        followWechat: "微信扫码关注我们"
    },
    aboutShow: {
        titleIntro: "展会介绍",
        titleHall: "展馆介绍",
        titleTraffic: "交通指引",
        intro: {
            p1: "江苏作为东部发达省份和和经济大省，产业集聚度高，建设科技成果丰富。为加强科技同经济对接、创新成果同产业对接、创新项目同现实生产力对接，江苏省住房和城乡建设厅打造了综合性、专业化、全链型服务平台——江苏绿色低碳建筑国际博览会，并获得商务部批复同意，是全省住房城乡建设领域唯一的党政机关举办展会保留清单内项目。",
            p2: "作为行业内最具规模的优质品牌展会之一，博览会特点突出。一是名企云集，创新成果集中呈现。博览会汇聚众多的世界 500强企业、上市公司、境外知名企业参展，重点展现新能源、新材料、数字化、智能化、先进制造等技术在建设领域的融合创新成果。二是平台开放，促进国际化交流。博览会邀请英国、法国、德国、意大利、瑞士、荷兰、芬兰、加拿大等国家的知名企业和机构参展参会，推动中外技术交流、人才互动、项目合作。三是活动纷呈，共商行业发展蓝图。博览会吸引行业协会学会、参展单位等举办推介发布、交流研讨、商务洽谈等活动，国内外专家学者、行业领军人物共谋发展，促进“政产学研金用”全链互动。四是精准对接，助力业务资源拓展。打造“永不落幕”的博览会，持续跟踪企业参展成效，提供对接服务，助力展商挖掘潜在商机，实现长效资源转化。五是全媒体赋能，打造立体宣传矩阵。与权威媒体合作开展全方位宣传报道，设立博览会直播间，邀请行业专家、企业代表和专业观众近距离交流互动。",
            p3: "博览会已成功举办两届，影响力持续提升。2025 博览会以“科技点亮绿色城乡”为主题，展示规模近 1.5 万平方米，共有119 家中外知名企业和机构参展，举办近 50 场同期活动，促成合作意向 59 项，涉及总金额约 140 亿元人民币，来自瑞典等 10余个国家地区及省内外近 1.7 万人次参观交流，较上届增加 42%。",
            p4: "2026 博览会规模将进一步扩大，以“科技创新赋能城乡高质量发展”为主题，于 2026 年 4 月 9 日至 11 日在南京国际博览中心举办，展示规模约 2.4 万平方米，展示内容包括城市更新、宜居韧性智慧城市、高品质住房、智能建造、绿色低碳建筑、特色田园、绿色金融等，并设置人才招聘、媒体中心、商务对接等功能服务区。届时，将首次采用“1+3”模式，邀请南京（主办地城市）以及苏南（苏州）、苏中（扬州）、苏北（盐城）各 1个城市作为主宾城市，共同做好博览会相关工作，推动构建全域参与、协同发展新格局。",
            p5: "我们诚挚邀请世界各国的优秀企业、行业机构及专业人士参与 2026 博览会，共同展示创新成果、分享先进经验、拓展合作平台，携手推动住房城乡建设高质量发展。"
        },
        hall: {
            p1: "南京国际博览中心位于南京市建邺区江东中路300号，2026博览会展示规模2个展馆，展出面积约24000平方米，预计观众达40000名。"
        },
        traffic: {
            publicTitle: "公共交通路线",
            publicLine1: "南京地铁10号线或2号线元通站4号出口",
            publicLine2: "南京公交85路或134路元通站",
            driveTitle: "外地车辆",
            driveTitleH5: "布撒展期外地货车进城行驶路线",
            driveLine1: "①上海方向沪蓉高速278出口（麒麟枢纽）--G2501三桥方向",
            driveLine2: "②杭州方向长深高速50A出口（东山枢纽）--G2501三桥方向",
            driveLine3: "③芜湖方向宁马高速2B出口（刘村立交）--G2501三桥方向",
            driveLine4: "④合肥方向宁合高速453A出口--451A（张店互通立交）--G2501三桥方向",
            driveLine5: "①/②/③/④--G2501--天后村收费站（南京绕城高速G2501-99号出口）--扬子江大道（奥体中心方向）--保双街（排队领证进馆）"
        },
        registerTip: "观众预登记窗口预计将于2023年10月1日上线，请搜索并关注“绿色低碳建筑国际博览会”微信公众号，及时获取更多官方资讯和互动信息。",
        tipTitle: "提示",
        confirm: "确定",
        cancel: "取消"
    },
    maneuver: {
        titleReg: "活动报名",
        registrationTitle: "观众登记",
        eventsTitle: "同期活动",
        guideTitle: "参观指南",
        updateSoon: "敬请更新",
        clickRegister: "点击报名",
        registerStatus: "报名情况查询",
        comingSoon: "敬请期待",
        newsTitle: "活动要闻",
        scheduleTitle: "展期活动—览表",
        scheduleTitleH5: "展期活动一览表",
        scheduleNote: "以下为2025江苏绿色低碳建筑国际博览会活动参考",
        placeholderPhone: "请输入手机号",
        placeholderName: "请输入姓名",
        phoneLabel: "手机号",
        nameLabel: "姓名",
        query: "查询",
        noResult: "未查询到报名信息",
        confirm: "确定",
        select: {
            mainReport: "主旨报告会",
            expertTalk: "名家话绿建",
            greenSeminar: "绿色低碳建筑专题研讨"
        },
        timeline: {
            d1: "2023年10月10日",
            d2: "2023年10月11日",
            t1: { time: "9:00-9:35", place: "4号馆入口处", event: "开馆仪式" },
            t2: { time: "9:50-12:00", place: "钟山厅3F", event: "主旨报告会" },
            t3: { time: "13:30-15:30", place: "南京201-202", event: "名家话绿建" },
            t4: { time: "14:00-17:00", place: "钟山厅3F", event: "绿色低碳建筑专题研讨" },
            t5: { time: "13:30-16:30", place: "南京206", event: "江苏-芬兰低碳建筑技术交流会" },
            t6: { time: "14: 00-17:00", place: "南京203", event: "高性能建筑门窗专题研讨" },
            t7: { time: "14:00-17:00", place: "扬子厅3F", event: "面向双碳目标的城市园林绿化高质量发展专题研讨" },
            t8: { time: "14:00-17:00", place: "南京302-303", event: "光储直柔专题研讨" },
            t9: { time: "14:00-15:30", place: "4号馆活动区", event: "政府投资工程集中建设信息发布会 (T21、T22)" },
            t10: { time: "9:00-12:00", place: "钟山厅3F", event: "建筑品质提升和绿色建专题研讨" },
            t11: { time: "14:00-17:00 ", place: "钟山厅3F", event: "第二届江苏省高效机房联盟大会" },
            t12: { time: "14:00-17:00", place: "钟山厅3F", event: "江苏省制冷学会青年会员论坛" },
            t13: { time: "9:00-12:00 ", place: "南京203", event: "C40中国清洁建造项目研讨会" },
            t14: { time: "9:00-12:00", place: "扬子厅3F", event: "双碳目标下的建筑节能与消防安全专题研讨" },
            t15: { time: "14:00-17:00", place: "扬子厅3F", event: "第六届绿色地下空间论坛" },
            t16: { time: "9:00-12:00", place: "南京302-303", event: "绿色农房分议题" },
            t17: { time: "14:00-17:00 ", place: "南京302-303", event: "绿色农房分议题" },
            t18: { time: "13:30-15:30 ", place: "4号馆", event: "“苏新创”发布（T23）" },
            t19: { time: "14:00-15:30", place: "4号馆", event: "中兴通讯与省住建厅相关战略" },
            t20: { time: "10月11日下午", place: "4号馆", event: "东南大学科研成果发布（T23）" },
            t21: { time: "10月11日下午", place: "4号馆", event: "东大设计院数字技术支持下的城市与建筑设计技术与产品推介" }
        },
        scheduleTable: maneuverScheduleZh
    },
    exhibitor: {
        signupTitle: "展商报名",
        signupDescription: "点击前往“联系我们”，获取参展报名方式与对接信息。",
        signupAction: "前往联系我们",
        listTitle: "2025博览会展商名录",
        directoryTitle: "2025博览会展商名录",
        listNote: "（展商顺序随机排列）",
        detailTitle: "展商风采",
        spotlightTitle: "展商风采",
        spotlightEmpty: "展商风采内容正在整理，后续将在此更新。",
        backToSpotlightList: "返回列表",
        manualTitle: "参展手册",
        manualName: "2026 江苏绿色低碳建筑国际博览会 展商手册",
        manualDownload: "2026 江苏绿色低碳建筑国际博览会展商手册",
        manualNameH5: "2026 江苏绿色低碳建筑国际博览会展商手册",
        manualDownloadH5: "2026 江苏绿色低碳建筑国际博览会 展商手册",
        quickGuideTitle: "快速指南",
        ejournalTitle: "电子会刊",
        ejournalName: "2026 江苏绿色低碳建筑国际博览会电子会刊",
        ejournalDownload: "2026 江苏绿色低碳建筑国际博览会电子会刊",
        serviceTitle: "展商服务",
        clickDownload: "点击下载",
        clickViewDownload: "点击查看下载",
        viewMore: "点击查看更多",
        more: "更多 >>",
        comingSoon: "敬请期待",
        tipTitle: "提示",
        confirm: "确定",
        cancel: "取消",
        ejournalTip: "电子会刊预计将于2023年10月1日上线，请搜索并关注“绿色低碳建筑国际博览会”微信公众号，及时获取更多官方资讯和互动信息。",
        tabs: {
            daily: "日常安排",
            customBuild: "特装搭建",
            customSubmit: "特装申报",
            standardRental: "标摊租用",
            otherService: "其他服务"
        },
        schedule: {
            checkInTitle: "展商报到时间安排",
            boothType: "展位类型",
            date: "日期",
            time: "时间",
            venue: "地点",
            standardBooth: "标摊展商",
            customBooth: "特装展商",
            loginHall: "3B 登录厅",
            moveTitle: "布展及撤展时间安排",
            schedule: "日程",
            openTime: "开放时间",
            moveIn: "布展",
            standardInstall: "标准展台布展搭建",
            customInstall: "特装展台布展搭建",
            moveOut: "撤展",
            openTitle: "展会开放时间",
            exhibitor: "展商",
            visitor: "观众",
            remark: "备注：本日程安排如有变动，请以最新通知为准。",
            checkInDate: "2026年4月7日—8日",
            moveInDateCustom: "4月7日 8:30-17:30 / 4月8日 8:30-20:00",
            moveInDateStandard: "4月8日 8:30-20:00",
            moveOutDate: "4月11日 15:30-24:00",
            exhibitDate910: "2026年4月9日",
            exhibitDate10: "2026年4月10日",
            exhibitDate11: "2026年4月11日",
            exhibitTimeExhibitor910: "8:30-17:30",
            exhibitTimeExhibitor11: "8:30-16:30",
            exhibitTimeVisitor910: "9:00-17:00",
            exhibitTimeVisitor11: "9:00-16:30"
        },
        contact: {
            designReview: "特装展位报图审核",
            designBuild: "特装设计、施工推荐",
            rental: "物品租赁申请",
            fascia: "标摊楣板申请及改动",
            transport: "展品运输、馆内运输、吊装施工、展品代收、仓储服务",
            person: "联系人",
            phone: "电话",
            mobile: "手机",
            email: "邮箱",
            huawei: "华玮",
            shigaofeng: "石高峰",
            zhulingyun: "朱凌云",
            tangxiaozhou: "唐小舟",
            niepeng: "聂鹏",
            luxuyang: "陆宇翔",
            zhouhuiqun: "周慧群",
            chenhu: "陈虎"
        },
        h5: {
            moveInTime: "布展时间",
            exhibitTime: "展出时间",
            committee: "组委会"
        }
    },
    contact: {
        title: "组委会",
        titleH5: "组委会联系方式",
        contactInfo: "联系方式",
        followWechat: "微信扫码关注我们",
        chen: "陈先生",
        zhou: "周女士"
    },
    people_server_map_address: {
        line_1: '一、地铁',
        line_2: '地铁2号线或10号线至元通站，4号口出步行5分钟即可到达4~7号展馆。',
        line_3: '南京南站： 乘坐地铁1号线南延线(往迈皋桥方向), 在安德门站下车，转乘地铁10号线(往奥体中心方向),在元通站下车(4号口出右转，沿江东中路走190米，右转进入白龙江西街直走280米到达)，步行至南京国际博览中心‚乘坐地铁3号线(往林场方向)，到达大行宫站，换乘地铁2号线（往油坊桥），在元通站下车(4号口出右转，沿江东中路走180米，右转进入白龙江西街直走280米到达)，步行至南京国际博览中心',
        line_4: '南京站：乘坐地铁1号线(往中国药科大学方向)，到达新街口站，换乘地铁2号线（往油坊桥），在元通站下车(4号口出右转，沿江东中路走180米，右转进入白龙江西街直走280米到达)，步行至南京国际博览中心',

        line_5: '二、公交',
        line_6: '1、江东中路白龙江东街-公交站 途经公交车：102路，109路',
        line_7: '2、江东中路金陵会议中心-公交站 途经公交车：b2路',
        line_8: '3、江东中路博览中心东门-公交站 途经公交车：102路，109路，b2路',
        line_9: '4、燕山路白龙江西街-公交站 途经公交车：102路，134路',
        line_10: '5、江东中路元通南-公交站 途经公交车：102路，109路，b2路',

        line_11: '三、有轨电车',
        line_12: '有轨电车1号线博览中心东门/元通站下',

        line_13: '四、自驾',
        line_14: '（一）到达展馆：',
        line_15: '1、上海方向为沪宁高速-绕城高速-306B出口-江山大街-江东中路/燕山路',
        line_16: '2、马鞍山芜湖方向为宁马高速-绕城高速-306B出口-江山大街-江东中路/燕山路合肥方向为宁合高速-长江三桥-绕城高速-306B出口-江山大街-江东中路/燕山路',
        line_17: '3、扬州方向为宁通高速-长江二桥-绕城高速-306B出口江山大街-江东中路/燕山路',
        line_18: '4、杭州方向为宁杭高速-机场高速-绕城高速-306B出口-江山大街-江东中路/燕山路',
        line_19: '（二）地下停车场：',
        line_20: '1、燕山路-博览中心下12号门进入展馆-根据现场指示前往P1停车场停车；P1停车场可提供1200个车位，同时设有25个大巴车位，临近1、2号展馆及3A登录厅。',
        line_21: '2、江东中路-博览中心7号门进入展馆-根据现场指示前往P2停车场停车（根据展会需求开放）；P2停车场可提供2200个停车位，临近4-9号展馆、6号门登录厅以及壹食馆（10号馆）。',
    },
    about: {
        line_1: "7月10日，江苏省住房和城乡建设厅在南京宣布，“2023江苏绿色低碳建筑国际博览会”将于2023年10月10日至11日在南京国际博览中心举办。",
        line_2: "据悉，本届博览会以“绿色城乡，迈向更低碳的未来”为主题，由江苏省住房和城乡建设厅、中国国际贸易促进委员会江苏省分会共同主办。博览会为期两天，将重点展示国内外绿色低碳建筑、城乡绿色低碳发展实践、智能建造与新型建筑工业化、城市更新、宜居宜业和美乡村等领域的最新技术成果，打造住房城乡建设绿色低碳交流平台，畅通供应商与采购商、国内市场与国际市场交易渠道。"
    },
    peopleServer: {
        tab1: "参观指南",
        tab2: "参观注册",
        tab3: "交通导图",
        tab4: "酒店住宿",
        tab5: "供需住宿",
        username: "姓名",
        flat: "单位",
        phone: "电话",
        datevisit: "参观日期",
        selectDate: "选择日期",
        verification: "验证码",
        submit: "提交",
        count: "内容",
        plh: "请输入内容",
        submitText: "提交留言",
        plhs: {
            username: "请输入姓名",
            flat: "请输入单位",
            phone: "请输入电话",
            datevisit: "请选择参观日期",
            verification: "请输入验证码",
            content: "请输入内容"
        },
        map: {
            title: "南京国际博览中心",
            subtitle: "地址：江苏省南京市建邺区江东中路300号"
        }
    },
    tabs: {
        exhibition: "展会概况",
        exhibitionSchedule: "展会活动",
        previousReview: "上届回顾",
        download: "资料下载",
        formbioa: "参展申请表",
    },
    shopServer: {
        tab1: "参展流程",
        tab2: "展位价格",
        tab3: "展位图",
        tab4: "搭建报馆",
        tab5: "交通路线",
        tab6: "广告宣传",
        tab7: "现场租赁",
        tab8: "酒店住宿",
        tab9: "参展商手册",
    },
    news: {
        tab1: "展会风采",
        tab2: "示范园风采",
        detail1: {
            title: "“绿色城乡，迈向更低碳的未来”丨2023江苏绿色低碳建筑国际博览会将于今年10月举办",
            strongTitle: "2023江苏绿色低碳建筑国际博览会",
            sub1: "通气会现场（一）",
            sub2: "通气会现场（二）",
            sub3: "通气会现场（三）",
            p1: "7月10日上午，江苏省住房和城乡建设厅召开2023江苏绿色低碳建筑国际博览会新闻通气会。省住房城乡建设厅总工程师路宏伟作情况介绍，中国国际贸易促进委员会江苏省分会副会长钱前等同志回答记者提问。",
            p2: "为深化与有关国家（地区）、国际组织在城乡建设绿色低碳发展方面的交流合作，发挥企业在建设科技创新中的主体作用，丰富完善建设科技创新成果推广体系，推动相关产业向高端化、智能化、绿色化、融合化发展，今年3月以来，省住房城乡建设厅结合主题教育，主动对接省有关单位，深入企业开展座谈交流，谋划进一步推动住房城乡建设领域科技创新，强化企业科技创新主体地位，贯通创新端、转化端、推广端、应用端的务实举措。通过调研，了解到社会各界对完善建设科技成果推广体系需求强烈，期待省厅搭建综合性的展示交易平台，拓展创新成果应用场景，深化国际交流合作。",
            p3: "因此，经批准，省住房城乡建设厅将联合省贸促会举办2023江苏绿色低碳建筑国际博览会（以下简称“博览会”），并将其作为省住房城乡建设厅唯一保留的党政机关展会活动。",
            p4: "路宏伟介绍，博览会以“绿色城乡，迈向更低碳的未来”为主题，由江苏省住房和城乡建设厅、中国国际贸易促进委员会江苏省分会共同主办，江苏省住房和城乡建设厅科技发展中心、江苏贸促国际会展有限公司具体承办，将于10月10日至11日在南京国际博览中心举办，会期2天。",
            p5: "博览会将重点展示国内外绿色低碳建筑、城乡绿色低碳发展实践、智能建造与新型建筑工业化、城市更新、乡村建设等领域的最新技术成果，打造住房城乡建设绿色低碳交流平台，畅通供应商与采购商、国内市场与国际市场交易渠道。",
            p6: "目前，博览会各项工作正在紧张地筹备中，相关工作将围绕三个方面开展：",
            p7Title: "一是坚持服务行业发展",
            p7: "展会期间，将邀请省内各地政府投资工程集中建设中心、保障房建设单位等采购商到会，发布其对技术、人才、产品等方面的需求，促进其与供应商形成合作意向或初步成果。",
            p8Title: "二是坚持突出科技创新",
            p8: "将重点邀请建筑业、房地产业、生产制造业、智慧物联产业等领域的头部企业参展，注重提升参展企业的国际化程度。还将邀请两院院士、设计大师作学术报告，交流绿色发展新理念、新技术、新路径。邀请苏州市人民政府、无锡市人民政府分别就苏州高铁新城、无锡锡东新城两个首批“城乡建设碳达峰碳中和先导区”的设计、建设、运管等情况进行专题推介发布。",
            p9Title: "三是坚持保障改善民生",
            p9: "将聚焦智慧家居、装配化装修、适老化改造等老百姓普遍关注的重点开展技术交流，展示最新成果，提出解决方案。",
            p10: "博览会期间，还将同步举办第十六届江苏绿色建筑发展大会及50多场精彩务实的系列活动，以期形成一个集技术推广、信息交流、产品交易、项目对接、产金合作、人才招聘于一体的行业综合服务平台。"
        },
        detail2: {
            title: "2023江苏绿色低碳建筑国际博览会正式启航！",
            marketTitle: "市场背景",
            marketP1: "党的二十大报告提出，要积极稳妥推进碳达峰碳中和，推进工业、建筑、交通等领域清洁低碳转型，推动形成绿色低碳的生产方式和生活方式。建筑领域是实现“双碳”目标的重要战场，据统计，2022年我国建筑领域碳排放约占全社会碳排放总量的52%。大力发展绿色低碳建筑，是推动城乡建设绿色低碳转型的重要举措。",
            marketP2: "习近平总书记强调，要强化科技同经济对接、创新成果同产业对接、创新项目同现实生产力对接、研发人员创新劳动同其利益收入对接，为我们以建设科技创新引领城乡建设高质量发展指明了前进方向，提供了根本遵循。",
            marketP3: "江苏建筑产业集聚度高，建设科技成果丰富，建筑产业链条完整，企业科技创新动力强劲，市场规模巨大。举办2023江苏绿色低碳建筑国际博览会，打造技术推广、信息交流、产品交易、项目对接、产金合作、人才招引的综合服务平台，有利于补齐建设科技创新短板，在建筑产业强链补链延链上展现新作为；有利于激发企业创新活力，在推动建设科技成果转化和建筑产业转型升级上取得新突破；有利于增强国际交流合作，在促进理念融通、技术联通、标准相通、人才互通上实现新提升。",
            baseTitle: "基本信息",
            inviteTitle: "邀请对象",
            inviteText: "住房城乡建设、科技、商务行政主管部门；建设、设计、建造、研发、咨询、材料和设备生产企业；金融机构、金融企业；省城乡建设碳达峰先导区、示范项目实施单位；相关行业协会、学会、研究会；高校、科研院所；各类人才、应届毕业生；相关媒体。",
            scopeTitle: "展示范围",
            highlightTitle: "展会亮点",
            highlightP1: "搭建住房城乡建设领域技术配对、产业对接、人才交流的专业平台，全面展示绿色低碳城乡发展四新成果、建设成就等，推进创新链产业链资金链人才链深度融合。",
            mediaTitle: "宣传服务 强大多元",
            mediaP1: "将邀请人民日报、新华网、经济日报、交汇点、新华日报、江苏卫视、荔枝网、江苏广播电台、南京日报、扬子晚报、中国建设报等50家媒体的80多名记者到会采访报道，宣传载体涵盖报纸、电视、期刊、网络、新媒体等各种媒介，扩大展会的知名度和影响力。",
            boothTitle: "展位规格",
            footerLine1: "展商报名请扫描二维码填写信息",
            footerLine2: "或点击文末左下角阅读原文报名"
        }
    },
    login: {
        homeTitle: "登录/注册",
        l_title: "欢迎登录",
        l_subtitle: "江苏绿色低碳建筑国际博览会平台",
        tab1: "账号登陆",
        tab2: "手机验证码登录",
        form1: "账号",
        form2: "密码",
        form3: "验证码",
        form4: "我已阅读并同意",
        form5: "用户手册",
        form6: "手机号",
        submit: "登录",
        form7: "注册账号",
        form8: "忘记密码",

        form9: "请完整阅读并同意以上协议",
        form10: "请完整阅读并同意用户协议",
        plh1: "请输入账号",
        plh2: "请输入密码",
        plh3: "请输入验证码",
        plh4: "请输入手机号",
        ret: "返回",
        form11: "登录成功"
    },
    reg: {
        title: "注册账号",
        form1: "发送验证码",
        form2: "邮箱",
        form3: "确认密码",
        form4: "注册",
        typeLabel: "注册类型",
        typeExhibitor: "我要参展",
        typeVisitor: "我要观展",
        plh1: "请输入邮箱地址",
        plh2: "请输入密码",
        plh3: "请输入验证码",
        plh4: "请输入正确的手机号",
        plh5: "请再次输入密码",
        plh6: "请输正确的身份证号码",
        sexRequired: "请选择性别",
        region: "地区",
        regionPlaceholder: "请选择所在地区",
        regionRequired: "请选择地区",
        company: "单位名称",
        companyRequired: "请填写单位名称",
        position: "职位",
        positionRequired: "请填写职位",
        typeRequired: "请选择注册类型",
        idCardRequired: "请填写身份证号",
        realNamePlaceholder: "请输入真实姓名",
        sex: "性别",
        idCard: "身份证号",
        form5: "真实姓名",
        form6: "男",
        form7: "女",
        realName: "真实姓名",
        form8: "两次输入的密码不一致",
        form9: "注册成功",
    },
    forget: {
        next: "下一步",
        form1: "重置密码",
        title: "忘记密码",
    },

    show_server_swiper: {
        swiper_text_1: '汉庭酒店(南京河西国际博览中心店)',
        swiper_text_2: '国际青年会议酒店',
        swiper_text_3: '南京金奥费尔蒙酒店',
        swiper_text_4: '南京新华传媒大酒店',
        swiper_text_5: '南京华泰万丽酒店',
        swiper_text_6: '南京奥体中心亚朵S酒店',
        swiper_text_7: '美居酒店奥体中心',
        swiper_text_8: '珍宝假日饭店(南京奥体中心店)',
        swiper_text_9: '南京国际博览中心酒店',
        swiper_text_10: '宜尚酒店(南京博览中心奥体东地铁站店)',
        swiper_text_11: '全季酒店(南京河西博览中心店)',
        swiper_text_12: '珍宝假日饭店凤台南路店',
    },
    swiper2: {
        line1: "技术配对、产业对接、人才交流",
        line1_1: "全面展示新成果、新成就",
        line2: "50多场同期活动",
        line2_1: "专题洽谈政策宣讲人才交流全覆盖",
        line3: "12000平米展览面积",
        line3_1: "400个标准展位",
        line4: "行业主管部门、行业链路企业、金融机构、",
        line4_1: "先导示范单位、行业协会、研究所、高校等",
        line5: "50家媒体、80多名记者",
        line5_1: "全方位扩大展会知名度和影响力",
    },
    newIndex: {
        line1: "2023江苏绿色低碳建筑国际博览会将于今年10月举办",
        line2: "7月10日上午，江苏省住房和城乡建设厅召开2023江苏绿色低碳建筑国际博览会新闻通气会。省住房城乡建设厅总工程师路宏伟作情况介绍，中国国际贸易促进委员会江苏省分会副会长钱前等同志回答记者提问。",
        line3: "2023江苏绿色低碳建筑国际博览会正式启航！",
        line4:"搭建住房城乡建设领域技术配对、产业对接、人才交流的专业平台，全面展示绿色低碳城乡发展四新成果、建设成就等，推进创新链产业链资金链人才链深度融合。",
        line5:"看完这条最“炫”的绿色低碳建筑国际博览会云探馆，解锁展区新技能",
        line6:"大力发展绿色低碳建筑，是践行绿色发展理念、改善人居环境、建设美丽中国的重要抓手，也是落实“碳达峰碳中和”目标，实现住房和城乡建设高质量发展的重要举措。",
       
        line7:"【展商风采】聚焦绿色可持续建筑 从樊笼中重返自然",
        line8:"今天介绍的是江苏江海杭萧绿色建筑科技有限公司、南京贝唐建筑科技有限公司、苏州佳固士新材料科技有限公司、江苏宜安建设有限公司、宏大建设集团、江苏擎天工业互联网有限公司、上海圣奎塑业有限公司、江苏扬建集团有限公司等八家企业。",
    
        line9:"【展商风采】绿色低碳 科技赋能建筑产业新风向",    
        line10:"今天介绍的是江苏省建筑科学研究院有限公司、苏州柯利达装饰股份有限公司、中亿丰控股集团有限公司三家企业。",
        line11: "向新向绿｜2025江苏绿色低碳建筑国际博览会圆满闭幕",
        line12: "江苏“好房子”“大家”谈",
        line13: "江苏公共建筑能源医院成立：开启建筑节能减碳“诊疗”新模式",
        line14: "许昆林在调研2025江苏绿色低碳建筑博览会时强调　加快建设安全舒适绿色智慧“好房子”不断满足人民群众优质住房新期待",
        line15: "国际人士盛赞2025江苏绿色低碳建筑国际博览会",
        line16: "江苏发布建设人民满意的改善型住宅倡议",
        line17: "“大家”齐聚 共话江苏改善型住宅建设",
        line18: "2025江苏绿色低碳建筑国际博览会隆重开幕——聚焦建设科技创新，共绘绿色城乡新图景",
        line19: "明天开展！入场方式、全程直播间通道看这里~",
        line20: "科技点亮绿色城乡 创新引领产业征程丨以创新为笔，以绿色为墨，合力绘就城乡建设发展新图景",
        line21: "预告 | “AI赋能住房城乡建设高质量发展专题交流会”等你来！",
        line22: "科技点亮绿色城乡 创新引领产业征程 | “双碳”引领，探索绿色城乡建设新路径",
        line23: "“科技点亮绿色城乡”——2025江苏绿色低碳建筑国际博览会将于4月1日开幕！",
        line24: "科技点亮绿色城乡 创新引领产业征程丨技术驱动，企业升级，创新之力铺就绿色未来",
        line25: "科技点亮绿色城乡 创新引领产业征程丨智能建造，塑造新时代“江苏建造”品牌",
        line26: "倒计时2天！一键领取2025江苏绿色低碳建筑国际博览会观展攻略~",
        line27: "倒计时3天！2025江苏绿色低碳建筑国际博览会同期活动、展位图抢先看~",
        line28: "科技点亮绿色城乡 创新引领产业征程丨挑大梁建设“好房子” 江苏系统化推动居住品质升级",
        line29: "2025江苏绿色低碳建筑国际博览会开始报名！",
        line30: "【2025江苏绿色低碳建筑国际博览会】展馆“剧透”",
        line31: "【预通知】2025江苏绿色低碳建筑国际博览会来啦！",
        line32: "【2025江苏绿色低碳建筑国际博览会】亮点抢先看！",
        line33: "【2025江苏绿色低碳建筑国际博览会】老朋友，新愿景（一）",
        line34: "【2025江苏绿色低碳建筑国际博览会】老朋友，新愿景（二）",
        line35: "2023江苏绿色低碳建筑国际博览会活动报名指南",
        line36: "2023江苏绿色低碳建筑国际博览会将于10月10日开幕！",
        line37: "“绿色城乡，迈向更低碳的未来” | 2023江苏绿色低碳建筑国际博览会将于今年10月举办",
        line38: "关于举办2023江苏绿色低碳建筑国际博览会的通知",
        line39: "2023江苏绿色低碳建筑国际博览会在南京开幕！",
        line40: "精彩回顾之一｜2023江苏绿色低碳建筑国际博览会",
        line41: "2023江苏绿色低碳建筑国际博览会正式启航！",
        line42: "看完这条最“炫”的绿色低碳建筑国际博览会云探馆，解锁展区新技能",
        line43: "Jiangsu Green & Low-Carbon Building International Expo set sail!",
        line44: "精彩回顾之二｜2023江苏绿色低碳建筑国际博览会",
        line45: "精彩回顾之三｜2023江苏绿色低碳建筑国际博览会"
    },
    newAbout:{
        
    }
}
